/** Validate browser-local input without inventing the server's selection rules. */
export function workflowActivationSchedule(
  start: string,
  end: string,
  startRequired: boolean,
  restoredInstants: { startUtc?: string; endUtc?: string } = {},
) {
  const startDate = parseLocalDateTime(start, restoredInstants.startUtc);
  const endDate = parseLocalDateTime(end, restoredInstants.endUtc);
  const startError = start
    ? startDate
      ? null
      : 'Enter a valid start date and time in your local timezone.'
    : startRequired
      ? 'Choose when this activation starts.'
      : null;
  let endError =
    end && !endDate
      ? 'Enter a valid end date and time in your local timezone.'
      : null;
  if (startDate && endDate && endDate.getTime() <= startDate.getTime()) {
    endError =
      'The end must be later than the start. The version is excluded at the end time.';
  }
  return {
    startError,
    endError,
    valid: !startError && !endError,
    startUtc: startDate?.toISOString() ?? null,
    endUtc: endDate?.toISOString() ?? null,
  };
}

function parseLocalDateTime(value: string, restoredUtc?: string): Date | null {
  if (!value) return null;
  const parts =
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?$/.exec(
      value,
    );
  if (!parts || Number(parts[1]) === 0) return null;
  const date = new Date(value);
  // Reject rolled calendar dates and nonexistent local times, including DST gaps.
  if (
    Number.isNaN(date.getTime()) ||
    date.getFullYear() !== Number(parts[1]) ||
    date.getMonth() + 1 !== Number(parts[2]) ||
    date.getDate() !== Number(parts[3]) ||
    date.getHours() !== Number(parts[4]) ||
    date.getMinutes() !== Number(parts[5]) ||
    date.getSeconds() !== Number(parts[6] ?? 0)
  )
    return null;
  // A repeated local hour can represent two instants. The caller supplies this only
  // while the input still equals the exact restored value from identity verification.
  const restoredDate = restoredUtc ? new Date(restoredUtc) : null;
  return restoredDate && !Number.isNaN(restoredDate.getTime())
    ? restoredDate
    : date;
}
